import { useCallback, useEffect } from 'react';
import { EV_SEARCH } from '../../tracking/events';
import Emitter from '../../utils/events';

let lastQuery: string | undefined = undefined;
let lastQueryLocation: string | undefined;

export default (result?: ICategory, resultQuery?: string) => {
  useEffect(() => {
    if (lastQuery && lastQuery === resultQuery) {
      lastQuery = undefined;
      Emitter.emit(EV_SEARCH, resultQuery, result, lastQueryLocation);
    }
  }, [lastQuery, resultQuery, result]);

  return useCallback((search?: string) => {
    if (search) {
      lastQueryLocation = location.href;
      lastQuery = search;
    }
  }, []);
};
